export const environment = {
  production: true,
  URL_API: 'https://demo.api.insuadvisor.com/api'
};
